import { NavIcon } from "./icons/icons";

const SiftedTrapezoid = ({ colour }: { colour: string }) => (
  <svg
    fill="none"
    height="60"
    width="60"
    viewBox="0 0 77 76"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m19.2295 0 57.335 33.1024-35.5522 42.3575-40.689366-23.492z"
      fill={colour}
    />
  </svg>
);

const Heading = ({ text, id }: { text: string; id: string }) => {
  return (
    <div className="flex items-center">
      <SiftedTrapezoid colour={"#E1EAFD"} />
      <span className="-ml-[44px] flex items-center">
        <span className="mr-3 inline-block">
          <NavIcon icon={id} colour={"#002EA5"} width={"22"} height={"22"} />
        </span>
        <h2 className="text-[24px] font-[700] leading-tight text-[#002EA5] md:text-[32px]">
          {text}
        </h2>
      </span>
    </div>
  );
};

export default Heading;
